import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config/api';
import secureStorage from '../utils/secureStorage';
import { startStatusPing } from '../utils/statusManager';
import { getDeviceFingerprintHeaders } from '../utils/deviceUtils';

// Lands a teacher coming from the center portal via a short-lived SSO token
// (?t=). Exchanges it for a real, device-bound main-web session (same anti-share
// model as a normal login), stores auth, then drops them into the exam app.
export default function SSOLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const t = new URLSearchParams(window.location.search).get('t');
    if (!t) { navigate('/login'); return; }

    (async () => {
      try {
        let deviceHeaders = {};
        try { deviceHeaders = getDeviceFingerprintHeaders() || {}; } catch (e) { /* ignore */ }

        const res = await fetch(`${API_BASE}/sso-exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...deviceHeaders },
          body: JSON.stringify({ token: t }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error((data && data.detail) || 'Không thể truy cập hệ thống luyện đề');

        localStorage.setItem('token', data.access_token);
        localStorage.setItem('role', data.role);
        if (data.email) localStorage.setItem('email', data.email);
        secureStorage.setItem('username', data.username);
        secureStorage.setItem('user_id', data.user_id);
        if (data.unique_session_id) secureStorage.setItem('unique_session_id', data.unique_session_id);

        // Strip the SSO token out of the URL/history.
        window.history.replaceState({}, document.title, '/');
        startStatusPing();
        navigate('/');
      } catch (e) {
        setError(e.message || 'Liên kết truy cập không hợp lệ hoặc đã hết hạn');
        setTimeout(() => navigate('/login'), 2500);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-teal-50/50 p-4">
      <div className="text-center">
        {!error ? (
          <>
            <div className="w-12 h-12 border-4 border-[#0096b1] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-slate-600">Đang đăng nhập vào hệ thống luyện đề…</p>
          </>
        ) : (
          <p className="text-red-500 font-medium">{error}</p>
        )}
      </div>
    </div>
  );
}
